import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { supabase } from '@/integrations/supabase/client';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

export default function AdminSeed() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSeedData = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const { data, error: invokeError } = await supabase.functions.invoke('seed-demo-data', {
        body: {}
      });

      if (invokeError) throw invokeError;

      setResult(data);
    } catch (err: any) {
      setError(err.message || 'Erro ao criar dados de demonstração');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Seed de Dados de Demonstração</h1>
          <p className="text-muted-foreground mt-2">
            Crie uma tenant de demonstração completa com dados fictícios
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Empresa Demo Dashi</CardTitle>
            <CardDescription>
              Esta ação criará uma tenant completa com:
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>✅ Usuário: teste@teste.com.br (senha: 123456)</li>
              <li>✅ Plano Enterprise ativo</li>
              <li>✅ 2 produtos de demonstração</li>
              <li>✅ 50 clientes fictícios</li>
              <li>✅ 10 meses de métricas (Jan-Out 2025)</li>
              <li>✅ MRR crescente (R$ 15k → R$ 52k)</li>
              <li>✅ 3 metas de negócio ativas</li>
              <li>✅ Métricas avançadas configuradas</li>
              <li>✅ 10 integrações de pagamento</li>
            </ul>

            <Button 
              onClick={handleSeedData} 
              disabled={loading || !!result}
              className="w-full"
              size="lg"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Criando dados...
                </>
              ) : result ? (
                <>
                  <CheckCircle className="mr-2 h-4 w-4" />
                  Dados criados com sucesso
                </>
              ) : (
                'Criar Tenant de Demonstração'
              )}
            </Button>

            {error && (
              <Alert variant="destructive">
                <XCircle className="h-4 w-4" />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            {result && result.success && (
              <Alert>
                <CheckCircle className="h-4 w-4" />
                <AlertDescription>
                  <div className="space-y-2">
                    <p className="font-semibold">{result.message}</p>
                    <div className="mt-2 p-3 bg-muted rounded-lg">
                      <p className="text-sm font-mono">
                        <strong>Email:</strong> {result.credentials?.email}
                      </p>
                      <p className="text-sm font-mono">
                        <strong>Senha:</strong> {result.credentials?.password}
                      </p>
                    </div>
                    {result.tenant && (
                      <div className="mt-2 text-sm text-muted-foreground">
                        <p>📦 {result.tenant.products} produtos criados</p>
                        <p>👥 {result.tenant.customers} clientes cadastrados</p>
                        <p>📊 {result.tenant.metricsMonths} meses de métricas</p>
                      </div>
                    )}
                  </div>
                </AlertDescription>
              </Alert>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
